// Set information and metadata
// Each set represents a purchasable LEGO set that can be bought with bricks or other sets

export interface ActionVisibility {
  actionId: string;
}

export interface SetInfo {
  id: string; // Set ID (e.g., "6772-1")
  name: string; // Display name
  photo: string; // Path to set image
  actionVisibility: ActionVisibility[]; // Actions/sets to unlock when purchased
}

// Alpha Team Cruiser
export const AlphaTeamCruiser: SetInfo = {
  id: "6772-1",
  name: "Alpha Team Cruiser",
  photo: "/sets/alpha_team_cruiser_6772-1.png",
  actionVisibility: [], // Empty for now
};

// Tahu
export const Tahu: SetInfo = {
  id: "8534-1",
  name: "Tahu",
  photo: "/sets/tahu_8534-1.png",
  actionVisibility: [], // Empty for now
};

// The Knight Bus
export const TheKnightBus: SetInfo = {
  id: "4866-1",
  name: "The Knight Bus",
  photo: "/sets/the_knight_bus_4866-1.png",
  actionVisibility: [], // Empty for now
};

// Eiffel Tower
export const EiffelTower: SetInfo = {
  id: "10307-1",
  name: "Eiffel Tower",
  photo: "/sets/eiffel_tower_10307-1.jpg",
  actionVisibility: [],
};

// Garbage Truck
export const GarbageTruck: SetInfo = {
  id: "4432-1",
  name: "Garbage Truck",
  photo: "/sets/garbage_truck_4432-1.png",
  actionVisibility: [],
};

// Himeji Castle
export const HimejiCastle: SetInfo = {
  id: "21060-1",
  name: "Himeji Castle",
  photo: "/sets/himeji_castle_21060-1.jpg",
  actionVisibility: [],
};

// TIE Fighter
export const TIEFighter: SetInfo = {
  id: "7146-1",
  name: "TIE Fighter",
  photo: "/sets/tie_fighter_7146-1.png",
  actionVisibility: [],
};

// Lloyd's Legendary Dragon
export const LloydsLegendaryDragon: SetInfo = {
  id: "71766-1",
  name: "Lloyd's Legendary Dragon",
  photo: "/sets/lloyds_legendary_dragon_71766-1.png",
  actionVisibility: [],
};

// Lion Knights' Castle
export const LionKnightsCastle: SetInfo = {
  id: "10305-1",
  name: "Lion Knights' Castle",
  photo: "/sets/lion_knights_castle_10305-1.png",
  actionVisibility: [],
};

// Millennium Falcon
export const MillenniumFalcon: SetInfo = {
  id: "10179-1",
  name: "Millennium Falcon",
  photo: "/sets/millennium_falcon_10179-1.jpg",
  actionVisibility: [],
};
